import styled from "styled-components";

export const Container = styled.div<{ $expanded?: boolean; $minimized?: boolean }>`
    position: absolute;
    bottom: 5px;
    right: 100px;
    background: white;
    border-radius: 8px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
    width: 350px;
    display: flex;
    flex-direction: column;
    max-height: ${({ $expanded }) => ($expanded ? "calc(100vh - 130px)" : "500px")};
    transition: all 0.3s ease;
    min-width: ${({ $minimized }) => ($minimized ? "auto" : undefined)};
`;

export const Header = styled.h4`
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
`;

export const HeaderTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        font-size: 14px;
        color: #64748b;
    }
`;

export const ToggleButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
    color: #64748b;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 18px;
    }

    &:hover {
        background: #f1f5f9;
        color: #2196f3;
    }
`;

export const Content = styled.div<{ $expanded?: boolean }>`
    overflow: auto;
    display: ${({ $expanded }) => ($expanded ? "block" : "none")};
`;

export const OperationsList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-right: 8px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
`;

export const OperationClass = styled.div`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const OperationClassHeader = styled.div`
    background: #f8fafc;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    padding: 10px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    transition: all 0.2s;

    &:hover {
        background: #f1f5f9;
        border-color: #2196f3;
    }
`;

export const OperationClassTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const OperationClassIcon = styled.span<{ $expanded?: boolean }>`
    display: flex;
    align-items: center;
    transition: transform 0.2s;
    transform: ${({ $expanded }) => ($expanded ? "rotate(180deg)" : "rotate(0)")};

    svg {
        font-size: 18px;
        color: #64748b;
    }
`;

export const OperationClassMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const OperationClassCount = styled.span`
    font-size: 10px;
    color: #64748b;
`;

export const OperationClassContent = styled.div<{ $expanded?: boolean }>`
    display: ${({ $expanded }) => ($expanded ? "block" : "none")};
    padding-left: 8px;
`;

export const OperationItem = styled.div`
    background: white;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        border-color: #2196f3;
        box-shadow: 0 2px 8px rgba(33, 150, 243, 0.15);
        transform: translateY(-1px);
    }
`;

export const OperationHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const OperationName = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const OperationCode = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    padding: 2px 5px;
    background: #f1f5f9;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 600;
    color: #475569;
`;

export const OperationAdherence = styled.div<{ $level: "high" | "medium" | "low" }>`
    font-size: 16px;
    font-weight: 700;
    color: ${({ $level }) => {
        if ($level === "high") return "#16a34a";
        if ($level === "medium") return "#d97706";
        return "#dc2626";
    }};
`;

export const OperationClassAdherence = styled(OperationAdherence)`
    font-size: 14px;
`;

export const OperationStats = styled.div`
    font-size: 11px;
    color: #64748b;
`;
